import axios from 'axios'
import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateStore(payload) {
    return requestPost(apiPath.STORE.path, payload)
  },

  GetOneStore(storeID) {
    return requestGet(`${apiPath.STORE.path}/${storeID}`)
  },

  GetAllStore(paging, sorting, filtering) {
    return requestGet(apiPath.STORE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_name: filtering.name,
      f_address: filtering.address,
      f_ipAddress: filtering.ipAddress,
      f_port: filtering.port,
      f_phoneNumber: filtering.phoneNumber,
      f_faxNumber: filtering.faxNumber,
      f_taxPercentage: filtering.taxPercentage,
      f_deliveryCharge: filtering.deliveryCharge,
      f_takeAwayCharge: filtering.takeAwayCharge,
      f_regionCode: filtering.regionCode,
      f_regionName: filtering.regionName,
      f_areaCode: filtering.areaCode,
      f_areaName: filtering.areaName,
      f_cityCode: filtering.cityCode,
      f_cityName: filtering.cityName,
      f_rscCode: filtering.rscCode,
      f_zipCode: filtering.zipCode,
      f_type: filtering.type,
      f_isActive: filtering.isActive,
      f_latitude: filtering.latitude,
      f_longitude: filtering.longitude,
      f_isOpen24Hours: filtering.isOpen24Hours,
      f_isHomeDelivery: filtering.isHomeDelivery,
      f_valueAddedTax: filtering.valueAddedTax,
      f_deliveryTax: filtering.deliveryTax,
      f_restaurantTax: filtering.restaurantTax
    })
  },

  UpdateStore(storeID, payload) {
    return requestPut(`${apiPath.STORE.path}/${storeID}`, payload)
  },

  DeleteStore(storeID) {
    return requestDelete(`${apiPath.STORE.path}/${storeID}`)
  },

  CheckStoreInfo(outletCode) {
    return requestGet(apiPath.STORE_INFO.path, {
      outletCode
    })
  },

  GetStorePin(outletCode) {
    return requestGet(apiPath.STORE_PIN.path, {
      outletCode
    })
  },

  UpdateStorePin(payload) {
    return requestPut(apiPath.STORE_PIN.path, payload)
  },

  CheckStorePin(payload) {
    return requestPost(apiPath.CHECK_STORE_PIN.path, payload)
  },

  GetRestaurantInfo(outletCode) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.HOME_APP_RESTAURANT_DETAIL.path
      }?id=${outletCode}&part=intro`,
      method: 'GET',
      responseType: 'json'
    })
  },

  /**
   * The following methods are methods for requesting new interfaces
   */
  GetAllStoreForNewPort(paging, sorting, filtering, uid) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STORES_LIST.path
      }`,
      method: 'get',
      params: {
        uid: uid || localStorage.getItem('UID'),
        sortby: sorting.byField,
        order: sorting.isDesc ? 'desc' : 'asc',
        page_index: paging.page,
        page_size: paging.size,
        name: filtering.name,
        address: filtering.address,
        phone_number: filtering.phone_number,
        area_name: filtering.area_name,
        city_name: filtering.city_name,
        id: filtering.id,
        outlet_code: filtering.outlet_code,
        type: filtering.type,
        tax_percentage: filtering.tax_percentage,
        area_code: filtering.area_code,
        city_code: filtering.city_code,
        is_active: filtering.is_active,
        is_open24_hours: filtering.is_open24_hours,
        latitude: filtering.latitude,
        longitude: filtering.longitude
      }
    })
  },

  GetOneStoreForNewPort(storeID) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STORES.path
      }`,
      method: 'get',
      params: {
        id: storeID
      }
    })
  },

  CreateStoreForNewPort(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STORES.path
      }`,
      method: 'post',
      data: payload
    })
  },

  UpdateStoreForNewPort(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STORES.path
      }`,
      method: 'patch',
      data: payload
    })
  },

  DeleteStoreForNewPort(deleteID) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STORES.path
      }`,
      method: 'delete',
      data: {
        id: deleteID
      }
    })
  },
  GetStoreCoupons(
    outletCode,
    orderType,
    phoneNumber: string | undefined = undefined
  ) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_STORES_COUPON_LIST.path
      }`,
      method: 'get',
      params: {
        uid: localStorage.getItem('UID'),
        outlet_code: outletCode,
        order_type: orderType,
        phone_number: phoneNumber
      }
    })
  },
  GetCouponList(
    outletCode,
    orderType,
    phoneNumber: string | undefined = undefined
  ) {
    return requestGet(apiPath.COUPON_LIST.path, {
      outletCode,
      orderType,
      phoneNumber
    })
  },
  GetQravedUserId() {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_USER_ID.path
      }`,
      method: 'post'
    })
  },
  GetStoreTables(outletCode) {
    return requestGet(apiPath.TABLES.path, {
      outletCode
    })
  },
  SetNewTable(data) {
    return requestPut(apiPath.ORDER_TABLE.path, {
      ...data
    })
  },
  GetBuildings(outletCode) {
    return requestGet(apiPath.BUILDINGS.path, {
      outletCode
    })
  },
  CheckUserRegistered(phoneNumber: string) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.CHECK_USER_REGISTERED.path
      }`,
      method: 'get',
      params: {
        uid: localStorage.getItem('UID'),
        phone_number: phoneNumber
      }
    })
  },
  CheckUserDetail(phoneNumber: string, outletCode: string) {
    return requestGet(apiPath.USER_DETAIL.path, {
      phoneNumber,
      outletCode
    })
  },
  PostUserRegister(payload) {
    return requestPost(apiPath.USER_REGISTER.path, payload)
  },
  UpdateUserTagging(payload) {
    return requestPut(apiPath.USER_UPDATE_TAGGING.path, payload)
  },
  GetPrintInterval(outletCode) {
    return requestGet(apiPath.PRINT_INTERVAL.path, {
      outletCode
    })
  },
  GetPrintOrder(outletCode) {
    return requestGet(apiPath.PRINT_ORDER.path, {
      outletCode
    })
  }
}

export default api
